import { render, staticRenderFns } from "./reason-list.vue?vue&type=template&id=5ab54522&"
import script from "./reason-list.vue?vue&type=script&lang=ts&"
export * from "./reason-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports